import { bootstrapApplication } from '@angular/platform-browser';
import { init, trackEvent } from '@aptabase/web';
import { appConfig } from './app/app.config';
import { App } from './app/app';

init('A-EU-8920644474');
trackEvent('app_started');

bootstrapApplication(App, appConfig)
  .then(() => {
    // Bootstrap réussi = index + chunks du shell à jour : on ré-arme la reprise auto de
    // GlobalErrorHandler (un futur chunk lazy obsolète pourra de nouveau déclencher UN reload).
    try {
      sessionStorage.removeItem('gaco.chunkReloaded');
    } catch {
      /* stockage indisponible : sans gravité */
    }
  })
  .catch((err) => console.error(err));

